export default "__VITE_ASSET__D1tQkDS2__"